<template>
    <div class="ReObjfilter" :class="[{'ObjfilterStyles':innerStyles}]">
        <div v-if="!isOpen" class="textRules">
            <p>{{ textRules }}</p>
            <base-button v-if="!readonly" @click="open()" class="btn btn-icon no-border btn-simple btn-primary my-0"><i class="tim-icons icon-pencil"></i></base-button>
            <!-- <div><base-button v-if="!readonly" @click="open()" class="btn btn-simple btn-primary my-0">Редактировать</base-button></div> -->
        </div>
        <div v-if="isOpen">
            <div class="rule " v-for="(rule,index) in localRules" :key="index">
                <div class="row mb-2" v-for="(row,rowIndex) in rule" :key="rowIndex">
                    <el-select  
                        class="col-md select-primary"
                        placeholder="Справочник"
                        v-model="row.catalog"
                        @change="row.values=[]"
                        filterable
                        >
                        <el-option
                            v-for="item in catalog_list"
                            class="select-primary"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                    <el-select  
                        class="col-md pl-0 select-primary"
                        placeholder="Значения"
                        v-model="row.values"
                        filterable
                        multiple
                        >
                        <el-option
                            v-for="item in (catalogs[row.catalog]||{options:[]}).options"
                            class="select-primary"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                    <base-button @click="delRuleRow(index,rowIndex)" class="my-0 mr-3 btn btn-icon btn-simple btn-danger"><i class="tim-icons icon-trash-simple"></i></base-button>
                </div>
                <div class="d-flex "><base-button @click="addRuleRow(index)" class="mt-0 mb-0 btn btn-simple btn-success"> <i class="tim-icons icon-simple-add"></i>Правило</base-button>
                <base-button @click="delRule(index)" class="my-0 btn btn-simple btn-danger"><i class="tim-icons icon-trash-simple"></i>Группу</base-button></div>
            </div>
            <div><base-button @click="addRule" class="mb-2 mt-0 btn btn-simple btn-success"><i class="tim-icons icon-simple-add"></i>Группа правил</base-button></div>
            <!-- <pre>{{ outRules }}</pre> -->
            <div><base-button @click="close" class="my-0 btn btn-success">Применить и закрыть</base-button></div>
        </div>
    </div>
</template>
<script> 
    import { Select, Option } from 'element-ui';
    export default {
		name: 'ReObjFilter',
		components: {
            [Option.name]: Option,
            [Select.name]: Select,
		},
		props: {
			value: String,
            pretty:{
                type:Boolean,
                default: false,
            },
            readonly:{
                type:Boolean,
                default: false,
            },
            innerStyles: {
                type:Boolean,
                default: true,
            },
            catalogs_list:{
                type: String,
                default: null,
            },
            showType:{
                type: Boolean,
                default: true,
            }
        },
        data () {
			return {
				ver: 1,
                isOpen:false,
				localRules:[],
                catalogs: {},
                catalog_list: []
			}
		},
        watch:{
            value(){
                try{
                    // this.localRules = JSON.parse(this.value);
                    this.readRules(this.value);
                }catch(e){
                    console.error(e);
                    this.localRules = [];
                }
            },
            outRules(val){
                let v = this.value.replace(/": /g,'":').replace(/, /g,',');
                // console.log('out',v,v!=val,val);
                if(v!=val){
                    this.$emit('input',val)
                }
            }
        },
        computed:{
            textRules(){
                if(this.localRules.lenth==0) return 'Нет';
                let o,v,l;
                return (this.localRules.map(r=>{
                    o=[];
                    r.forEach(row => {
                        v=[].concat(row.values);
                        l=v.pop();
                        // o[row.catalog] = row.values
                        if(this.catalogs[row.catalog]){
                            o.push((this.showType?(this.catalogs[row.catalog].name)+': ':'')+(
                                v.length>0?v.map(i=>this.catalogs[row.catalog].list[i]).join(', ')+' и ':''
                            )+this.catalogs[row.catalog].list[l])
                        }
                    });
                    return o.join('; ');
                })).join('\n')
            },
            outRules(){
                if(this.localRules.lenth==0) return '';
                let o;
                // console.log(this.localRules);
                return JSON.stringify(this.localRules.map(r=>{
                    o={};
                    r.forEach(row => {
                        o[row.catalog] = row.values
                    });
                    return o;
                }),null,this.pretty?2:null)
            }
        },
        methods:{
            open(){
                if(this.readonly) return false;
                this.isOpen=true;
                if(this.localRules.length==0)
                    this.addRule();
            },
            close(){
                this.isOpen=false;
                let value = this.outRules;
                this.$emit('input', value);
            },
            delRuleRow(i1,i2){
                this.localRules[i1].splice(i2,1);
            },
            delRule(i){
                this.localRules.splice(i,1);
            },
            readRules(value){
                let val =  this.value;
                try{
                    // console.log('objFilter rules', val);
                    if(val=='') val='[]';
                    let rules = JSON.parse(val);
                    this.localRules = rules.map(r=>Object.keys(r).map(key=>({catalog:key,values:Array.isArray(r[key])?r[key]:[r[key]]})));
                }catch(e){
                    console.error(e, val);
                }
            },
            addRule(){
                this.localRules.push([]);
                this.addRuleRow(this.localRules.length-1);
            },
            addRuleRow(index){
                this.localRules[index].push({catalog:'',values:[]})
            },
            loadFilters(){
                // console.log('load obj filters')
                this.$GVO.ApiCall('get_filter_catalogs',{obj:'MyObj',flt:{catalogs:this.catalogs_list}},{useCache:true})
                .then((objApi) => {
                    this.catalogs = objApi.data;
                    let v;
                    Object.values(this.catalogs).forEach(c=>{
                        v={};
                        c.options.forEach(o=>{
                            v[o.value] = o.label
                        })
                        c.list = v;
                    })
                    this.catalog_list = Object.keys(objApi.data).map(key=>({label:objApi.data[key].name, value:key}))
                })
            }
        },
        mounted(){
            this.loadFilters();
            this.readRules();
        }
    }
</script>
<style scoped>
.textRules {display: flex; flex-direction: column; /*align-items: center;*/}
.textRules {flex-direction: row; justify-content: space-between;}
.textRules p {margin-right: 5px; }
.ObjfilterStyles {border: 1px dashed #01B0E0; border-radius: 6px; padding: 10px;/**/}

.rule { border-radius: 6px;     display: flex;
    flex-direction: column;
    flex-wrap: wrap;}
.rule:not(:last-child) { margin-bottom: 8px;}
/* .rule:nth-child(odd) {background-color: #f1f6fc;} */
.rule:nth-child(even) {background-color: #9e77f31a;}
/* .rule:nth-child(odd) {background-color: #f1f6fc;} */
/* .rule:nth-child(even) {background-color: #9e77f32c;} */
/* div {padding:3px; margin:2px; border: 1px solid #ddd;} */
</style>